import { Box, Grid, Link, Paper, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Info } from "@/components/VulnerabilityWatch/Info.tsx";
import type { KnownPortalOverview } from "@/types";
import { buildFigureViews, type FigureView } from "@/utils/portalOverview.ts";

function Figure({ figure }: { readonly figure: FigureView }) {
  return (
    <Box>
      <Typography variant="overline" color="text.secondary">{figure.label}<Info text={figure.tip} /></Typography>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        {figure.href ? <Link component={RouterLink} to={figure.href} underline="hover">{figure.value}</Link> : figure.value}
      </Typography>
      {figure.caption && <Typography variant="caption" color="text.secondary">{figure.caption}</Typography>}
    </Box>
  );
}

export default function PortalFigures({ overview }: { readonly overview: KnownPortalOverview | null }) {
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {buildFigureViews(overview).map((figure) => (
          <Grid key={figure.label} size={{ xs: 6, md: 3 }}><Figure figure={figure} /></Grid>
        ))}
      </Grid>
    </Paper>
  );
}
